import { NofshonUploadsComponent } from './nofshon-chul-uploads/nofshon-chul-uploads.component';
import { NofeshChulDetailsComponent } from './nofshon-chul-details/nofshon-chul-details.component';
import { nofshonimChulHomeComponent } from './home/nofshonim-chul-home.component';
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CanActivateViaOAuthGuard } from '../oAuth.canActivateGuard';
import { OrderNofeshChulComponent} from './order/order-nofshon-chul.component'
import { PirteyNofshimComponent } from './pirtey-nofshim/pirtey-nofshim.component';
import { PirteyTashlumComponent } from './pirtey-tashlum/pirtey-tashlum.component';
import { NofshonChulEndRishumComponent } from './nofshon-chul-end-rishum/end-rishum.component';

//import {UploadComponent} from //'./uploads/uploads.component';


@NgModule({
    imports: [RouterModule.forChild([
        {
            path: 'nofshonim-chul', component: nofshonimChulHomeComponent, canActivate: [CanActivateViaOAuthGuard], children: [

                // { path: '', redirectTo: 'nofesh-detail', pathMatch: 'full' },
                { path: 'nofesh-details/:id', component: NofeshChulDetailsComponent }, 
                { path: 'order/:id', component: OrderNofeshChulComponent}, 
                { path: 'pirtey-nofshim/:id', component: PirteyNofshimComponent }, 
                { path: 'pirtey-tashlum/:id', component: PirteyTashlumComponent},
                { path: 'end-rishum', component: NofshonChulEndRishumComponent},
                { path: 'uploads/:id', component:NofshonUploadsComponent }
                
            ]
        }

    ])],
    exports: [RouterModule]
})

export class NofshonimChulRouting {

}